import { createAsyncThunk } from '@reduxjs/toolkit'
import { CheckoutPatientAttributes, CheckoutPatientData } from 'components/modules/patientArea/products/types'
import nestApiService from 'services/api/nest-api-service'
import { getOpenJwtToken } from 'utils/getOpenJwtToken'

interface createPatientDataParams {
  apiPath: string
  data: CheckoutPatientAttributes
  partner_name?: string | null
}

export const createPatientData = createAsyncThunk<CheckoutPatientData, createPatientDataParams>(
  'create-patient-data',
  async ({ apiPath, data, partner_name }, { rejectWithValue }) => {
    try {
      const token = await getOpenJwtToken()

      const apiData = {
        patient_attributes: {
          ...data,
          cgu_accepted: true,
          cpf_number: data.cpf,
          first_name: data.firstName,
          last_name: data.lastName,
          phone_number: data.phoneNumber,
          gender: data.gender,
          terms_of_service: true,
          ...(partner_name && { partner_name })
        }
      }
      const response = await nestApiService.apiInstance.post(`/${apiPath}/user`, apiData, {
        headers: {
          Authorization: token
        }
      })
      return response.data
    } catch (error: any) {
      return rejectWithValue(error)
    }
  }
)
